/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'

const $nsid = 'app.bsky.feed.getLikes'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  likes: /*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Like>((() => like) as any)),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get like records which reference a subject (by AT-URI and CID). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Like = {
  $type?: 'app.bsky.feed.getLikes#like'
  indexedAt: l.DatetimeString
  createdAt: l.DatetimeString
  actor: ActorDefs.ProfileView
}

export type { Like }

const like = /*#__PURE__*/ l.typedObject<Like>(
  $nsid,
  'like',
  /*#__PURE__*/ l.object({
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    actor: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
  }),
)

export { like }
